export const eventImagePath = (path: string): string | null => {
  if (path) return path;

  return null;
};
